import { TextField, Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { IUIConfiguration } from "../model"
import { setTempUiConfigUndoRedo } from "../tools/undo-redo"

interface IUiConfigPageTitleProps {
  uiConfig: IUIConfiguration
}

export const UiConfigPageTitle = React.memo(({ uiConfig }: IUiConfigPageTitleProps) => {
  return (
    <FlexBox vertical ai="start" gap=".5rem" sx={{ mb: "1rem" }}>
      <Typography color="textPrimary" fontSize="1rem" fontWeight="bold">
        {translate("admin.ui-configuration.html.tags")}
      </Typography>
      <FlexBox gap>
        <Typography color="textPrimary" fontSize=".85rem" sx={{ minWidth: "4rem" }}>
          {translate("admin.ui-configuration.tag.title")}
        </Typography>
        <TextField
          value={uiConfig.page_title}
          required
          size="small"
          onChange={event =>
            setTempUiConfigUndoRedo({
              ...uiConfig,
              page_title: event.target.value
            })
          }
        />
      </FlexBox>
    </FlexBox>
  )
})
